export class Log {
    static debug(pMsg) {
        console.log(Log.FormatMsg(pMsg));
    }
    static info(pMsg) {
        console.info(Log.FormatMsg(pMsg));
    }
    static warn(pMsg) {
        if (Log.onWarn != null) {
            Log.onWarn(pMsg);
        }
        console.warn(Log.FormatMsg(pMsg));
    }
    static error(pMsg, pError) {
        if (Log.onError != null) {
            Log.onError(pMsg, pError);
        }
        let tMsg = Log.FormatMsg(pMsg);
        if (pError != null) {
            tMsg += " ";
            if (pError instanceof Error) {
                tMsg += pError;
                if (pError.stack != null)
                    tMsg += " Stack: " + pError.stack;
            }
            else {
                /* eslint-disable-next-line @typescript-eslint/no-base-to-string */
                tMsg += "Error: " + pError;
            }
        }
        console.error(tMsg);
    }
    //// private ///////////////////////////////////////////////////////////////////////////////
    static FormatMsg(pMsg) {
        const tDate = new Date();
        const tTimeStr = `${tDate.getHours()}:${tDate.getMinutes()}:${tDate.getSeconds()}:${tDate.getMilliseconds()}`;
        return (`[W-CF ${tTimeStr}] ${pMsg}`);
    }
}
export default Log;
